module.exports = __webpack_public_path__ + "static/img/claim.bf4ab840.png";